import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./StaffLogin.css";

const StaffLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    // Simulate network delay for professional feel
    setTimeout(() => {
      if (username === "thehexaplay" && password === "HexA@plaY") {
        localStorage.setItem("staffAuth", "true");
        localStorage.setItem("staffUser", username);
        navigate("/StaffDashboard");
      } else {
        setError("Invalid username or password. Please try again.");
      }
      setLoading(false);
    }, 600);
  };

  return (
    <div className="staff-login-page">
      <div className="staff-login-container">
        {/* Badge */}
        <div className="staff-login-badge">
          <span className="staff-login-dot"></span>
          Staff Portal Login Page
        </div>

        {/* Shield Icon */}
        <div className="staff-login-icon">
          <svg 
            width="32" 
            height="32" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            <path d="m9 12 2 2 4-4" />
          </svg>
        </div>

        <h1 className="staff-login-title">Welcome, Staff</h1>
        

        <form onSubmit={handleSubmit} className="staff-login-form">
          {error && <div className="staff-login-error">{error}</div>}

          <div className="staff-input-group">
            <label>Admin Username</label>
            <div className="staff-input-wrap">
              <svg 
                className="staff-input-icon" 
                width="20" 
                height="20" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
              <input
                type="text"
                placeholder="Enter admin username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoFocus
              />
            </div>
          </div>

          <div className="staff-input-group">
            <label>Password</label>
            <div className="staff-input-wrap">
              <svg 
                className="staff-input-icon" 
                width="20" 
                height="20" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="staff-password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                tabIndex="-1"
              >
                {showPassword ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>
          </div>

          <button 
            type="submit" 
            className="staff-login-button" 
            disabled={loading}
          >
            {loading ? (
              <span className="staff-login-spinner"></span>
            ) : (
              <>
                Access Dashboard <span className="staff-arrow">→</span>
              </>
            )}
          </button>
        </form>

        <div className="staff-login-divider">
          <span>OR</span>
        </div>

        <a href="#" className="staff-forgot-link" onClick={(e) => { e.preventDefault(); alert("Contact IT support for password reset"); }}>
          Forgot Password?
        </a>
      </div>
    </div>
  );
};

export default StaffLogin;